// extracted by mini-css-extract-plugin
export default {"container":"ErrorFallback_container__NPAHP","dark":"ErrorFallback_dark__IsTCG","title":"ErrorFallback_title__0cy-S"};